export default __webpack_public_path__ + "static/media/login-v2.fbb12b0e.png";